import { ApplicationType } from '@lighthouse/core'
import React from 'react'
import styled from 'styled-components'

import { Desktop } from './Desktop'
import { Mobile } from './Mobile'
import type { PlatformProps } from './types'
import { WxApplet } from './WxApplet'

const SCxWrapper = styled.div`
    width: 100%;
    height: 100%;
    padding-left: 153px;
    padding-top: 59px;
    background: linear-gradient(180.61deg, #fcfcfc 16.04%, #e3f0ff 52.41%, #e8c2ff 143.05%);
`

const SCxWxWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

interface PreviewProps extends PlatformProps {
    appType: ApplicationType
}

export const Preview: React.FC<PreviewProps> = ({ appType, ...rest }) => {
    return appType === ApplicationType.WEBSITE ? (
        <SCxWrapper>
            <Desktop {...rest} />
            <Mobile {...rest} />
        </SCxWrapper>
    ) : (
        <SCxWxWrapper>
            <WxApplet {...rest} />
        </SCxWxWrapper>
    )
}
